"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _commonCta = require("@mmc/common-cta");
var _clsx = _interopRequireDefault(require("clsx"));
var _editorialNews = _interopRequireDefault(require("./editorial-news.css"));
var _card = _interopRequireDefault(require("./card"));
var _slider = _interopRequireDefault(require("./slider/slider"));
var _useMediaQuery = _interopRequireDefault(require("./utils/useMediaQuery"));
var isTablet = function isTablet() {
  return (0, _useMediaQuery["default"])('(min-width: 768px) and (max-width: 1024px)');
};
var isTabletOrMobile = function isTabletOrMobile() {
  return (0, _useMediaQuery["default"])('(max-width: 1024px)');
};
var EditorialNews = function EditorialNews(props) {
  var theme = props.theme,
    data = props.data,
    language = props.language;
  var title = data.title,
    cardVariant = data.cardVariant,
    backgroundColor = data.backgroundColor,
    enableMobileCarousel = data.enableMobileCarousel,
    cta = data.cta,
    cardItems = data.cardItems,
    removeTopMargin = data.removeTopMargin,
    removeBottomMargin = data.removeBottomMargin;
  var carouselSettings = {
    dots: true,
    infinite: isTablet() ? true : false,
    speed: 500,
    slidesToShow: isTablet() ? 1.2 : 1,
    slidesToScroll: 1
  };
  var isCarouselVisible = isTabletOrMobile() && enableMobileCarousel;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_editorialNews["default"].editorialNews, _editorialNews["default"][backgroundColor], removeTopMargin && _editorialNews["default"].removePaddingTop, removeBottomMargin && _editorialNews["default"].removePaddingBottom)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_editorialNews["default"].col, theme['col-xs-12'], theme['col-sm-offset-1'], theme['col-sm-10'], _editorialNews["default"].contentWrapper)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialNews["default"].tagWrapper
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: _editorialNews["default"].editorialTitle
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialNews["default"].viewAllCtaDesktop
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      url: cta == null ? void 0 : cta.url,
      label: cta == null ? void 0 : cta.label,
      openNewTab: cta == null ? void 0 : cta.openNewTab,
      priority: 'low',
      ctaTheme: backgroundColor
    }
  }))), !isCarouselVisible && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_editorialNews["default"].cardsWrapper, _editorialNews["default"][cardVariant], removeTopMargin && _editorialNews["default"].removeMarginTop, removeBottomMargin && _editorialNews["default"].removeMarginBottom)
  }, cardItems && cardItems.map(function (card, i) {
    return /*#__PURE__*/_react["default"].createElement(_card["default"], {
      language: language,
      theme: theme,
      data: card,
      variant: cardVariant,
      colNum: i
    });
  })), isCarouselVisible && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_editorialNews["default"].carouselCardWrapper, _editorialNews["default"][cardVariant], removeTopMargin && _editorialNews["default"].removeMarginTop, removeBottomMargin && _editorialNews["default"].removeMarginBottom)
  }, /*#__PURE__*/_react["default"].createElement(_slider["default"], {
    settings: carouselSettings
  }, cardItems && cardItems.map(function (card, i) {
    return /*#__PURE__*/_react["default"].createElement(_card["default"], {
      language: language,
      theme: theme,
      data: card,
      variant: cardVariant,
      colNum: i
    });
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialNews["default"].viewAllCtaMobile
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      url: cta == null ? void 0 : cta.url,
      label: cta == null ? void 0 : cta.label,
      openNewTab: cta == null ? void 0 : cta.openNewTab,
      priority: 'low',
      ctaTheme: backgroundColor
    }
  }))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
EditorialNews.resourceType = function () {
  return 'NewsCards_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(EditorialNews);
exports["default"] = _default;